import { render, staticRenderFns } from "./AdministratorSnippet.vue?vue&type=template&id=7374f01a&scoped=true"
import script from "./AdministratorSnippet.vue?vue&type=script&lang=js"
export * from "./AdministratorSnippet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7374f01a",
  null
  
)

export default component.exports